export const UPDATE = "UPDATE";

export const update = (cache: any) => ({
  type: UPDATE,
  cache,
});
